<template>
  <!-- 主要内容 -->
  <div class="person-main">
     <div v-if="mydata.userFavoritesArr.length === 0">
      <p style="line-height: 300px; text-align: center; letter-spacing: 1px;color:#999999">
        暂无收藏
      </p>
    </div>
    <div class="box-myActivityCards" v-else>
      <myActivityCards
        v-for="(item, index) in mydata.userFavoritesArr"
        :key="index"
        :info="item.content"
        path="/layout/list/thematicDetails"
      >
      </myActivityCards>
    </div>

    <!--分页 -->
    <div
      class="gl-pagination"
      
    >
      <el-pagination
        v-model:currentPage="mydata.pageObj.currentPage"
        v-model:page-size="mydata.pageObj.pageSize"
        :total="mydata.pageObj.total"
        layout="prev, pager, next"
        pager-count="4"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";

import { reactive, computed, toRefs } from "vue";

import myActivityCards from "@/views/personalCenter/components/myActivityCards/index.vue";

//引入我的收藏列表、取消收藏接口
import {
  userFavoritesList,
  delFavoritesList,
} from "@/api/personalCenter/myCollection/index.js";
import { ElMessage, ElMessageBox } from "element-plus";
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  size: "default",

  // currentPage3: "5",
  // pageSize3: "100",
  small: false,
  background: false,
  disabled: false,

  // circleUrl:
  //   "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

  sizeList: ["small"],

  /////
  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 4, // 每页条数
    total: 0, // 总的条数
  },

  userFavoritesArr: [], //收藏列表

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //获取的用户信息

  type: "4", //写死-类型就是4
});

// const { circleUrl, sizeList } = toRefs(mydata);

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  userFavoritesFn();
}




//获取收藏列表
function userFavoritesFn() {
  userFavoritesList(mydata.userInfo.jwt, { type: mydata.type,
      page: String(mydata.pageObj.currentPage),
      psize: String(mydata.pageObj.pageSize),
   }).then((res) => {
    mydata.userFavoritesArr = res.data.list;
    // console.log("zhuantihuodong1",res.data.list)
    mydata.pageObj.total = res.data.count;
  });
}

userFavoritesFn();



//取消收藏
function cancelCollect(item) {
  ElMessageBox.confirm("是否取消收藏该条数据？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      // 调用接口
      delFavoritesList(mydata.userInfo.jwt, { favorite_id: item.id }).then(
        (res) => {
          ElMessage({
            message: res.msg,
            type: "success",
          });
          // 查询列表
          userFavoritesFn();
        }
      );
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "已取消操作",
      });
    });
}


</script>

<style scoped lang="scss">
//主要内容
.person-main {
  // border:1px solid red;
  //  padding-bottom:40px;
  
  .box-myActivityCards {
    // height: 1040px;
    // border:1px solid red;
     min-height: 500px;
    // border:1px solid blue;
  }

  .big-box{
    margin-top:16px;
  }
  // .big-box:last-of-type{
  //   margin-bottom:0px;
  // }

  //////////分页
  .paging {
    // margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 40px;
    :deep(.el-button.is-plain) {
      margin-left: 24px;
    }
  }
  //最左边的箭头
  :deep(.btn-prev.is-first) {
    margin-right: 12px;
    background-color: #f5f6f7;
  }
  :deep(.btn-next) {
    background-color: #f5f6f7;
  }
  //每个页
  :deep(.number) {
    margin-right: 12px;
    // color:#BBBDBF;
    background-color: #f5f6f7;
  }
  //省略号
  :deep(.more.btn-quicknext.el-icon) {
    margin-right: 12px;
    background-color: #f9f9f9;
  }

  .demo-pagination-block + .demo-pagination-block {
    margin-top: 10px;
  }
  .demo-pagination-block .demonstration {
    margin-bottom: 16px;
  }
}
</style>